export const Add = 'Add';
export const AddN = 'AddN';
export const Atan2 = 'Atan2';
export const AvgPool = 'AvgPool';
export const AvgPoolBackprop = 'AvgPoolBackprop';
export const AvgPool3D = 'AvgPool3D';
export const AvgPool3DBackprop = 'AvgPool3DBackprop';
export const BatchMatMul = 'BatchMatMul';
export const BatchToSpaceND = 'BatchToSpaceND';
export const BroadcastTo = 'BroadcastTo';
export const Complex = 'Complex';
export const Concat = 'Concat';
export const Conv2D = 'Conv2D';
export const Conv2DBackpropFilter = 'Conv2DBackpropFilter';
export const Conv2DBackpropInput = 'Conv2DBackpropInput';
export const Conv3D = 'Conv3D';
export const Conv3DBackpropFilterV2 = 'Conv3DBackpropFilterV2';
export const Conv3DBackpropInputV2 = 'Conv3DBackpropInputV2';
export const Cumsum = 'Cumsum';
export const DepthToSpace = 'DepthToSpace';
export const DepthwiseConv2dNative = 'DepthwiseConv2dNative';
export const DepthwiseConv2dNativeBackpropFilter = 'DepthwiseConv2dNativeBackpropFilter';
export const DepthwiseConv2dNativeBackpropInput = 'DepthwiseConv2dNativeBackpropInput';
export const Diag = 'Diag';
export const Div = 'Div';
export const Elu = 'Elu';
export const EluGrad = 'EluGrad';
export const Equal = 'Equal';
export const FloorDiv = 'FloorDiv';
export const Fill = 'Fill';
export const FusedBatchNorm = 'FusedBatchNorm';
export const GatherNd = 'GatherNd';
export const Greater = 'Greater';
export const GreaterEqual = 'GreaterEqual';
export const Identity = 'Identity';
export const Imag = 'Imag';
export const Less = 'Less';
export const LessEqual = 'LessEqual';
export const LRN = 'LRN';
export const LRNBackprop = 'LRNBackprop';
export const Max = 'Max';
export const Maximum = 'Maximum';
export const MaxPool = 'MaxPool';
export const MaxPoolBackprop = 'MaxPoolBackprop';
export const MaxPool3D = 'MaxPool3D';
export const MaxPool3DBackprop = 'MaxPool3DBackprop';
export const MaxPoolWithArgmax = 'MaxPoolWithArgmax';
export const Minimum = 'Minimum';
export const Mod = 'Mod';
export const Multiply = 'Multiply';
export const NotEqual = 'NotEqual';
export const NonMaxSuppressionV3 = 'NonMaxSuppressionV3';
export const NonMaxSuppressionV5 = 'NonMaxSuppressionV5';
export const OneHot = 'OneHot';
export const PadV2 = 'PadV2';
export const Pool = 'Pool';
export const Pow = 'Pow';
export const Prelu = 'Prelu';
export const Real = 'Real';
export const Relu = 'Relu';
export const Relu6 = 'Relu6';
export const SelectV2 = 'SelectV2';
export const Selu = 'Selu';
export const SpaceToBatchND = 'SpaceToBatchND';
export const SplitV = 'SplitV';
export const SquaredDifference = 'SquaredDifference';
export const Square = 'Square';
export const Sub = 'Sub';
export const Tile = 'Tile';
export const Transpose = 'Transpose';
/**
 * TensorFlow.js-only kernels
 */
export const FromPixels = 'FromPixels';
//# sourceMappingURL=kernel_names.js.map